import React from 'react'
import { Pagination as BsPagination } from 'react-bootstrap'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { setResponsiveValues, i18nTranslate } from 'src/utils'
import { isEquinoxMysiteAdmin } from 'src/utils/mySiteUtils'
import { scrollUtilities } from 'src/utils/customScrollManager'
import './styles.scss'

@observer
class Pagination extends React.Component {
  nameSpace = 'ssr-resource'
  @observable active = this.props.active
  @observable start = this.props.startPage
  @observable end = this.calculateRange()

  static defaultProps = {
    className: '',
    totalPages: 10,
    startPage: 1,
    numOfPaginationsToShow: setResponsiveValues(5, 4, 3),
    handlePagination: () => {},
    scrollToTop: true,
    scrollContainerId: null,
    enableScrollOnlyForMysite: false,
  }
  componentDidMount() {
    this.getCurrentPageNumber()
  }
  componentDidUpdate(prevProps) {
    this.checkAndUpdateComponent(prevProps)
  }
  checkAndUpdateComponent(prevProps) {
    const { active, totalPages } = this.props
    if (prevProps.totalPages !== totalPages) {
      this.start = this.props.startPage
      this.active = this.props.active
      this.end = this.calculateRange()
    }
    if (prevProps.active !== active) {
      this.active = active
      this.getCurrentPageNumber()
    }
  }

  getCurrentPageNumber() {
    const totalPagesToShow = this.calculateRange()
    const acutalPaginationsToShow =
      totalPagesToShow <= this.props.numOfPaginationsToShow
        ? totalPagesToShow
        : this.props.numOfPaginationsToShow

    const addedPageCount = this.active + acutalPaginationsToShow - 1

    if (this.active === 1 || addedPageCount <= this.props.totalPages) {
      this.start = this.active
    } else if (addedPageCount >= totalPagesToShow) {
      const remainingPagesCount = addedPageCount - this.props.totalPages
      this.start = Math.abs(this.active - remainingPagesCount)
    }
    this.end = this.start + (acutalPaginationsToShow - 1)
  }
  calculateRange() {
    return this.props.totalPages >= this.props.numOfPaginationsToShow
      ? this.props.numOfPaginationsToShow
      : this.props.totalPages
  }

  scrollToTopOfPage = () => {
    const { scrollToTop, scrollContainerId, enableScrollOnlyForMysite } =
      this.props
    if (!scrollToTop || (enableScrollOnlyForMysite && !isEquinoxMysiteAdmin()))
      return

    if (scrollContainerId) {
      scrollUtilities.scrollToTop(scrollContainerId)
      return
    }

    const scrollTarget =
      document.querySelector('.modal-body') ||
      document.querySelector('.modal-content') ||
      document.querySelector('.modal-dialog')

    if (scrollTarget) {
      scrollTarget.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      scrollUtilities.scrollToTop()
    }
  }
  handleClickEvent = value => {
    event.preventDefault()
    const { startPage, totalPages } = this.props
    switch (value) {
      case 'prevIndex':
        this.active = this.active === startPage ? startPage : --this.active
        break
      case 'nextIndex':
        this.active = this.active === totalPages ? totalPages : ++this.active
        break
      case 'firstIndex':
        this.active = startPage
        break
      case 'lastIndex':
        this.active = totalPages
        break
      default:
        this.active = value
    }
    this.getCurrentPageNumber()
    this.props.handlePagination(this.active)
    this.scrollToTopOfPage()
  }

  ellipsis = props => {
    if (props === 'start' && this.start > 1) {
      return <BsPagination.Ellipsis />
    }
    if (props === 'end' && this.end < this.props.totalPages) {
      return <BsPagination.Ellipsis />
    }
  }
  renderPageNumbers = () => {
    const items = []
    for (let number = this.start; number <= this.end; number++) {
      items.push(
        <BsPagination.Item
          className="item-wrapper text-align-center"
          key={number}
          aria-label={`Gotopage ${number}`}
          onClick={() => this.handleClickEvent(number)}
          active={number == this.active}
          data-testid={`qa-plp-page-number-${number}`}>
          {number}
        </BsPagination.Item>
      )
    }
    return (
      <>
        {this.ellipsis('start')}
        {items}
        {this.ellipsis('end')}
      </>
    )
  }
  render() {
    const isFirstTriggerDisabled =
      this.start === 1 && this.active === 1 && 'd-none'
    const isLastTriggerDisabled = this.active == this.end && 'd-none'
    const { totalPages } = this.props
    if (totalPages <= 1) {
      return <></>
    }
    return (
      <BsPagination
        className={`pagination-wrapper mt-3 ${
          this.props.alignPagination === 'start'
            ? 'justify-content-start'
            : this.props.alignPagination === 'center'
              ? 'justify-content-center'
              : 'justify-content-end'
        } ${this.props.className}`}
        data-testid="qa-pagination-wrapper">
        <BsPagination.First
          className={`${isFirstTriggerDisabled} pagination-first`}
          data-testid="qa-first-trigger"
          onClick={() => this.handleClickEvent('firstIndex')}
          aria-label={i18nTranslate('catalog.FirstPage', 'first page', {
            nameSpace: this.nameSpace,
          })}
        />
        <BsPagination.Prev
          className={`${isFirstTriggerDisabled} pagination-prev`}
          data-testid="qa-prev-trigger"
          onClick={() => this.handleClickEvent('prevIndex')}
          aria-label={i18nTranslate('catalog.PreviousPage', 'previous page', {
            nameSpace: this.nameSpace,
          })}
        />
        {this.renderPageNumbers()}
        <BsPagination.Next
          className={`${isLastTriggerDisabled} pagination-next`}
          data-testid="qa-next-trigger"
          onClick={() => this.handleClickEvent('nextIndex')}
          aria-label={i18nTranslate('catalog.NextPage', 'next page', {
            nameSpace: this.nameSpace,
          })}
        />
        <BsPagination.Last
          className={`${isLastTriggerDisabled} pagination-last`}
          data-testid="qa-last-trigger"
          onClick={() => this.handleClickEvent('lastIndex')}
          aria-label={i18nTranslate('catalog.LastPage', 'last page', {
            nameSpace: this.nameSpace,
          })}
        />
      </BsPagination>
    )
  }
}

export default Pagination
export { Pagination }
